module.exports = __webpack_public_path__ + "img/ch18_03_轻语答案.156666c2.jpg";